import { GUI } from 'lil-gui'
import { DirectionalLight } from 'three';
import { MyColors } from '../mat/MyColors';

export class Params {

    public static gui:GUI;
    public static width:number = 512;
    public static height:number = 512;
    public static wire:THREE.Mesh;
    public static dLight:DirectionalLight;

    public static colorId:number = 0;
    public static colorMax:number = 5;
    public static sizeId:number = 0;
    public static formationId:number = 0;
    public static spaceId:number = 0;
    public static isPreviewed:boolean=false;

    public static duration:number=3;
    public static interval:number = 12;//sec

    public static init(){

        

        this.gui = new GUI();
        this.gui.domElement.style.display="none";

        document.addEventListener('keydown', (event) => {
            const keyName = event.key;
            if(keyName=="d"){
                if(this.gui){
                    if(this.gui.domElement.style.display=="none"){
                        this.gui.domElement.style.display="block";
                    }else{
                        this.gui.domElement.style.display="none";
                    }    
                }
            }
        });


        Params.colorId = Math.floor( Params.random() * Params.colorMax );
        Params.sizeId = Math.floor( Params.random()* 2 );
        //Params.formationId = Math.floor( Params.random()* FormationData.list.length );
        //Params.spaceId = Math.floor( Params.random() * 2 );

        let a =Params.gui.addFolder("features");
        a.add(Params,"colorId");
        //a.add(Params,"sizeId");
        //a.add(Params,"formationId");

        (window as any).$fxhashFeatures = {
            //"color": Params.colorId,
            //"size": Params.sizeId,
            //"space": Params.spaceId,
            //"formation": Params.formationId
        }

        MyColors.init();
    }

    public static getFirstSize():number{

       return Params.getTargetSize(Params.sizeId);

    }

    public static getRandomSize():number{

        return Params.getTargetSize(Math.floor(Params.random()*2));

    }

    public static getTargetSize(sizeId:number):number{

        let ss = 1;
        switch(sizeId){
            case 0:
              ss=1;
              break;
            case 1:
              ss=1.25;
              break;
            case 2:
              ss=1.5;
              break;
          }
        return ss;
        

    }


    public static preview(){
        if(Params.isPreviewed)return;

        let hoge = window as any;
        if(hoge.fxpreview!=null){
            Params.isPreviewed=true;
            console.log("preview");
            return hoge.fxpreview();
        }
    }


    public static random():number{

        let hoge = window as any;
        if(hoge.fxrand==null) return Math.random();
        return hoge.fxrand();
        
    }

}